import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  ScrollView,
  Dimensions,
  // Switch,
  Platform,
  Image,
} from "react-native";
import Text from "../components_v2/TextFont";
import * as ImagePicker from "expo-image-picker";
// import * as FileSystem from "expo-file-system";

import * as Actions from "../actions/AreaActions";
import { translate } from "../locales/translate";
import ArButton from "../argon-ui/Button";
import Theme from "../argon-ui/Theme";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";
import {
  faBars,
  faEdit,
  faImage,
  faKey,
} from "../../assets/consts/faCharCodes";
import Loading from "../components/Loading";
import { SimpleIcon } from "../components_v2/Buttons";
import * as AreaTypes from "../components/areas/_areaType";
import Switch from "../components/ToggleSwitch";
import InputBase from "../nativeBase-ui/InputBase";
import { HStack, VStack } from "native-base";
import Select from "../nativeBase-ui/Select";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import AppLog from "../logger";

const breach_Delay = [
  {
    label: `30 ${translate("timer.second")}`,
    value: 30,
  },
  {
    label: `60 ${translate("timer.second")}`,
    value: 60,
  },
  {
    label: `120 ${translate("timer.second")}`,
    value: 120,
  },
];
class AreaFormScreen extends Component {
  static navigationOptions = ({ navigation, screenProps: { translate } }) => {
    if (
      navigation.state.params &&
      (navigation.state.params.areaId || navigation.state.params.areaUId) &&
      (navigation.state.params.accessLevel == "Admin" ||
        navigation.state.params.accessLevel == "Support")
    ) {
      return {
        headerTitle: translate("navigation.AreasList"),
        ///headerTitle: () => <LogoTitle />,
        headerRight: () => {
          return (
            <Menu
              ref={(r) => (this._MenuRef = r)}
              anchor={
                <Text
                  onPress={() => {
                    this._MenuRef.show();
                  }}
                  style={{ paddingHorizontal: 10 }}
                >
                  <SimpleIcon icon={faBars} size={24} />
                </Text>
              }
            >
              {/* === Devices === */}
              <MenuItem
                onPress={() => {
                  this._MenuRef.hide();
                  let { areaId, areaUId } = navigation.state.params;

                  navigation.navigate("Devices", { areaId, areaUId });
                }}
              >
                {translate("area.devices")}{" "}
                {navigation.state.params.devices != undefined &&
                  navigation.state.params.devices.length > 0 &&
                  `(${navigation.state.params.devices.length})`}
              </MenuItem>
              {/* === Area Logs == */}
              <MenuItem
                onPress={() => {
                  this._MenuRef.hide();
                  // let { areaId, areaUId } = navigation.state.params;
                  let { areaId, areaUId } = navigation.state.params;
                  // var _areaId = areaId;
                  // if (typeof areaId == "number") {
                  //   areaId = areaId;
                  // } else if (typeof areaUId == "string") {
                  //   areaId = areaUId;
                  // }
                  navigation.navigate("AreaLogs", { areaId, areaUId });
                }}
              >
                {translate("area.logs")}
              </MenuItem>
              {/* === DefinedStates === */}
              <MenuItem
                onPress={() => {
                  this._MenuRef.hide();
                  let { areaId, areaName, areaUId, uId } =
                    navigation.state.params;
                  navigation.navigate("AreaStates", {
                    areaId,
                    uId,
                    areaName,
                    areaUId,
                  });
                }}
              >
                {translate("area.DefinedStates")}
              </MenuItem>
              {/* === Area Users === */}
              <MenuItem
                onPress={() => {
                  this._MenuRef.hide();
                  let { areaId, areaName, areaUId } = navigation.state.params;
                  var _areaId = areaId;
                  if (typeof areaId == "number") {
                    areaId = areaId;
                  } else if (typeof areaUId == "string") {
                    areaId = areaUId;
                  }
                  navigation.navigate("AreaUsers", {
                    areaId: _areaId,
                    areaName,
                  });
                }}
              >
                {translate("area.areaUsers")}
              </MenuItem>
              <MenuDivider />
              {/* === Remove Area === */}
              <MenuItem
                onPress={() => {
                  this._MenuRef.hide();
                  let { areaId, areaUId } = navigation.state.params;
                  navigation.navigate("AreaRemove", {
                    areaId: areaId || areaUId,
                  });
                }}
              >
                {translate("navigation.AreaRemove")}
              </MenuItem>
            </Menu>
          );
        },
      };
    }

    return { headerTitle: translate("navigation.AreasList") };
  };

  constructor(props) {
    super(props);
    this.imageUpload = null;
    this._MenuRef = undefined;

    var passedData = this.props.navigation.state.params || {};
    this.state = {
      ...passedData,
      accessToken: null,
      showImagePickerButtons: false,
      serverUrl: "",
      adminCanArm:
        passedData.areaId || passedData.areaUId
          ? passedData.rolesAllowedToArm &&
            passedData.rolesAllowedToArm
              .toLowerCase()
              .split(",")
              .includes("admin")
          : true,
      memberCanArm:
        passedData.areaId || passedData.areaUId
          ? passedData.rolesAllowedToArm &&
            passedData.rolesAllowedToArm
              .toLowerCase()
              .split(",")
              .includes("member")
          : false,
      showOnHomeScreen:
        passedData.areaId || passedData.areaUId
          ? passedData.showOnHomeScreen
          : true,
      showAreaImage:
        (passedData.areaId || passedData.areaUId) &&
        passedData.imageSource != null
          ? true
          : false,
      // validation.
      autoJoin:
        passedData.areaId || passedData.areaUId ? passedData.autoJoin : false,
      validation_areaName_hasError: false,

      showingValidationErrors: false,
      validationErrors: "",
      buildingId: null,

      // === bathroom type ===
      showBathroomOption: false,
      extra: {
        gender: passedData.extra?.gender || "public",
        isOutOfService: passedData.extra?.isOutOfService || false,
      },
      // === sec
      pinCode: passedData.pinCode || null,
      breachDelay: passedData.breachDelay || breach_Delay[1].value,
      showSecureArea: false,
    };
    this.BathroomType = ["men", "women", "public"];
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let selectedType = nextProps.AreaReducer.areaTypes.find(
      (item) => item.id == prevState.areaTypeId
    );
    if (selectedType && selectedType.name === AreaTypes.BATHROOM) {
      return { showBathroomOption: true };
    }
    return null;
  }
  componentDidMount() {
    //this.getPermissionAsync();
    const { accessToken } = this.props.AppReducer?.currentServer;
    this.getServerUrlAsync();
    this.fetchAreaTypes(accessToken);
    this.setState({
      buildingId: this.props.AppReducer.currentBuilding.buildingId,
      accessToken,
    });
  }

  goBack = () => {
    this.props.navigation.navigate("Areas");
  };

  save = () => {
    // call reducer to add a new area.
    var token = this.state.accessToken;
    var _rolesAllowedToArm = [];
    var rolesAllowedToArm = "";
    if (this.state.adminCanArm) _rolesAllowedToArm.push("Admin");
    if (this.state.memberCanArm) _rolesAllowedToArm.push("Member");
    if (_rolesAllowedToArm.length > 0)
      rolesAllowedToArm = _rolesAllowedToArm.join(",");
    var model = {
      areaId: this.state.areaId || 0,
      areaUId: this.state.areaUId || null,
      parentAreaId: this.state.parentAreaId,
      parentAreaUId: this.state.parentAreaUId,
      parentAreaName: this.state.parentAreaName,
      areaName: this.state.areaName,
      areaTypeId: this.state.areaTypeId,
      imageSource: this.state.showAreaImage
        ? this.state.imageSource || null
        : null,
      imageUpload: this.imageUpload,
      buildingId: this.state.buildingId,
      //isArmable: this.state.isArmable,
      rolesAllowedToArm,
      autoJoin: this.state.autoJoin,
      showOnHomeScreen: this.state.showOnHomeScreen,
      // === Touch Panel ===
      pinCode: this.state.pinCode,
      breachDelay: this.state.breachDelay,
    };
    // === find Bathroom areaType ===
    let selectedType = this.props.AreaReducer.areaTypes.find(
      (item) => item.id == model.areaTypeId
    );

    if (selectedType && selectedType.name) {
      switch (selectedType.name.toLowerCase()) {
        case AreaTypes.BATHROOM.toLowerCase():
          // always pass values as string
          var extra = {
            gender: this.state.extra.gender,
            isOutOfService: this.state.extra.isOutOfService,
          };
          model["extra"] = extra;
          break;

        default:
          break;
      }
    }

    // validation
    var validationMessage = "";
    if (!model.areaName) {
      this.setState({ validation_areaName_hasError: true });
      validationMessage += `${translate("area.areaName")} ${translate(
        "app.isRequired"
      )}\r\n`;
    }

    if (!model.areaTypeId) {
      validationMessage += `${translate("area.areaType")} ${translate(
        "app.isRequired"
      )}\r\n`;
    }

    if (validationMessage) {
      this.showAlert(validationMessage);
      return;
    }
    // console.log("model", model);
    if (model.areaId || model.areaUId) {
      this.props.update(model, token);
    } else {
      this.props.add(model, token);
    }
    // then go back to list
    this.goBack();
  };

  pickImageAsync = async (userCamera) => {
    var result;
    var pickOptions = {
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [1, 1], //[16, 9]
      quality: 0.5,
      base64: true,
      exif: true,
    };

    if (userCamera) {
      var httpClient = axios.create();

      try {
        result = await ImagePicker.launchCameraAsync(pickOptions);
        AppLog(
          httpClient,
          this.props.AppReducer.serverUrl,
          `uri resolved in AreaFormScreen image picker: ${result.uri}`,
          "debug"
        );
      } catch (error) {
        AppLog(
          httpClient,
          this.props.AppReducer.serverUrl,
          `error on AreaFormScreen image picker: ${error}`,
          "debug"
        );
      }
    } else {
      try {
        result = await ImagePicker.launchImageLibraryAsync(pickOptions);
        AppLog(
          httpClient,
          this.props.AppReducer.serverUrl,
          `uri resolved in AreaFormScreen image picker: ${result.uri}`,
          "debug"
        );
      } catch (error) {
        AppLog(
          httpClient,
          this.props.AppReducer.serverUrl,
          `error on AreaFormScreen image picker: ${error}`,
          "debug"
        );
      }
    }
    // console.log(result.uri);

    if (!result.cancelled && result.uri) {
      try {
        // console.log(result.uri);
        // console.log(result.base64);
        this.setState({
          imageSource: result.uri,
        });
        this.imageUpload = result.base64;
        var cacheName = result.uri.substring(result.uri.lastIndexOf("/") + 1);
        var fileNameDest = `${FileSystem.cacheDirectory}images/areas/${cacheName}`;
        console.log(fileNameDest);
        await FileSystem.copyAsync({
          from: result.uri,
          to: fileNameDest,
        }).then(() => {
          this.setState({
            imageSource: result.uri,
            showImagePickerButtons: false,
          }).catch(console.log);
          // console.log(this.state.imageSource);
        });
      } catch (e) {
        AppLog(e);
      }
    }
  };

  getPermissionAsync = async () => {
    if (Constants.platform.ios) {
      const { status } = await Permissions.askAsync(Permissions.CAMERA_ROLL);
      if (status != "granted") {
        alert(":(");
      }
    }
  };

  getServerUrlAsync = async () => {
    if (!this.state.serverUrl) {
      const serverUrl = this.props.AppReducer.serverUrl;
      this.setState({ serverUrl });
    }
  };

  fetchAreaTypes = (accessToken) => {
    if (!this.props.AreaReducer.areaTypesLoaded) {
      this.props.fetchAreaTypes(accessToken);
    }
  };

  showAlert = (message = "") => {
    this.setState({
      validationErrors: message,
      showingValidationErrors: true,
    });
  };

  hideAlert = () => {
    this.setState({
      validationErrors: "",
      showingValidationErrors: false,
    });
  };
  changeOptionHandler = (value) => {
    let areaType = this.props.AreaReducer.areaTypes.find(
      (item) => item.id == value
    );
    var showBathroomOption = false;
    if (areaType.name == AreaTypes.BATHROOM) {
      showBathroomOption = true;
    }
    this.setState({
      areaTypeId: areaType.id,
      showBathroomOption,
    });
  };
  changeBreachDelayHandler = (value) => {
    let _breachDelay = breach_Delay.find((item) => item.value == value);
    this.setState({
      breachDelay: _breachDelay.value,
    });
  };
  render() {
    if (!this.props.AreaReducer.areaTypesLoaded) {
      return <Loading />;
    }
    const model = this.state || {};
    let _isAdmin =
      this.state.accessLevel == "Admin" || this.state.accessLevel == "Support";
    let imgSourceResolver = Actions.resolveImageSource(
      model.areaId,
      model.imageSource,
      this.state.serverUrl,
      this.state.accessToken
    );
    const screenTitle = model.areaId
      ? model.areaName || translate("app.noName")
      : translate("area.createNewArea");
    return (
      <KeyboardAvoidingView
        behavior="height"
        style={{ flex: 1 }}
        enabled={true}
        keyboardVerticalOffset={80}
      >
        <ScrollView style={style.container}>
          <Text style={style.screenTitle}>{screenTitle}</Text>
          {this.state.parentAreaName && (
            <Text style={{ textAlign: "center", color: Theme.COLORS.MUTED }}>
              {translate("area.subAreaFor")} {this.state.parentAreaName}
            </Text>
          )}
          {/* <TouchableHighlight
            underlayColor="#EEE"
            onPress={() => {
              this.setState({
                showImagePickerButtons: !this.state.showImagePickerButtons,
              });
            }}
          >
            <View style={{ flex: 1 }}>
              <Image style={style.img} source={imgSourceResolver} />
              <View
                style={
                  this.state.showImagePickerButtons
                    ? style.btnPickImageGroup_Show
                    : style.btnPickImageGroup_Hide
                }
              >
                <ArButton
                  color="info"
                  style={style.btnPickImageAr}
                  round
                  onPress={() => this.pickImageAsync(false)}
                >
                  <Text style={{ color: "#FFF" }}>
                    {translate("pickImage.fromGallery")}
                    <Icon
                      name="picture"
                      family="antdesign"
                      size={30}
                      color="#FFF"
                    />
                  </Text>
                </ArButton>
                <ArButton
                  color="info"
                  style={style.btnPickImageAr}
                  round
                  onPress={() => this.pickImageAsync(true)}
                >
                  <Text style={{ color: "#FFF" }}>
                    {translate("pickImage.fromCamera")}
                    <Icon
                      name="camera"
                      family="antdesign"
                      size={30}
                      color="#FFF"
                    />
                  </Text>
                </ArButton>
                <ArButton
                  color="muted"
                  style={style.btnPickImageAr}
                  round
                  onPress={() =>
                    this.setState({ showImagePickerButtons: false })
                  }
                >
                  {translate("app.cancel")}
                </ArButton>
              </View>
            </View>
          </TouchableHighlight> */}
          {/* area name */}
          <View style={{ marginVertical: 10 }}>
            <InputBase
              label={translate("area.areaName")}
              placeholder=""
              isInvalid={this.state.validation_areaName_hasError}
              icon={faEdit}
              onChangeText={(txt) =>
                this.setState({
                  areaName: txt,
                  validation_areaName_hasError: txt.length == 0,
                })
              }
              value={this.state.areaName}
            />
          </View>
          {/* area type */}
          <Select
            label={translate("area.areaType")}
            placeholder={translate("app.selectAnItem")}
            data={this.props.AreaReducer.areaTypes.map((a) => {
              return { label: translate(`areaType.${a.name}`), value: a.id };
            })}
            value={this.state.areaTypeId || undefined}
            onChangeText={(value, index, data) => {
              this.changeOptionHandler(value);
            }}
          />
          {/* === bathroom Options === */}
          {this.state.showBathroomOption && (
            <View style={{ marginBottom: 10, backgroundColor: "transparent" }}>
              <Select
                label={translate("app.usage")}
                data={this.BathroomType.map((type) => {
                  return {
                    label: translate(`bathroom.${type}`),
                    value: type,
                  };
                })}
                value={this.state.extra.gender}
                onChangeText={(value, index, data) => {
                  this.setState({
                    extra: {
                      gender: value,
                      isOutOfService: this.state.extra.isOutOfService,
                    },
                  });
                  // this.setState({ areaTypeId: value });
                }}
              />
              <View style={style.wrapper}>
                <Switch
                  isOn={this.state.extra.isOutOfService}
                  size="small"
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  onToggle={(value) => {
                    this.setState({
                      extra: {
                        gender: this.state.extra.gender,
                        isOutOfService: value,
                      },
                    });
                  }}
                />
                <Text style={style.switchText}>
                  {translate("bathroom.isOutOfService")}
                </Text>
              </View>
            </View>
          )}
          {/* check boxes */}
          {(_isAdmin || !this.state.areaId) && (
            <View>
              {/* showOnHomeScreen */}
              <View style={style.wrapper}>
                <Switch
                  label={translate("area.showOnHomeScreen")}
                  isOn={this.state.showOnHomeScreen}
                  size="small"
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  onToggle={(value) => {
                    this.setState({ showOnHomeScreen: value });
                  }}
                />
              </View>
              {/* === Secure section  */}
              <View style={style.wrapper}>
                <Switch
                  isOn={this.state.showSecureArea}
                  size="small"
                  onColor={Theme.COLORS.ACTIVE}
                  offColor={Theme.COLORS.MUTED}
                  onToggle={(value) => {
                    this.setState({
                      showSecureArea: value,
                    });
                  }}
                />
                <Text style={style.switchText}>
                  {translate("area.showSecureArea")}
                </Text>
              </View>

              {this.state.showSecureArea && (
                <>
                  {/* === PinCode Input === */}
                  <View style={{ marginVertical: 10 }}>
                    <InputBase
                      secureTextEntry={true}
                      label={translate("area.PinCodeLabel")}
                      placeholder=""
                      // isInvalid={this.state.validation_areaName_hasError}
                      icon={faKey}
                      onChangeText={(txt) =>
                        this.setState({
                          pinCode: txt,
                        })
                      }
                      value={this.state.pinCode}
                    />
                  </View>
                  {/* === Touch Panel Pin Code === */}
                  <VStack>
                    <Select
                      label={translate("area.breachDelayLabel")}
                      placeholder={translate("app.selectAnItem")}
                      data={breach_Delay}
                      value={this.state.breachDelay}
                      onChangeText={(value, index, data) => {
                        this.changeBreachDelayHandler(value);
                      }}
                    />
                    <Text style={{ fontSize: 10 }}>
                      {translate("area.hintPinCode", {
                        breachDelay: this.state.breachDelay,
                      })}
                    </Text>
                  </VStack>
                  {/* armable admin */}
                  <View style={style.wrapper}>
                    <Switch
                      isOn={this.state.adminCanArm}
                      size="small"
                      onColor={Theme.COLORS.ACTIVE}
                      offColor={Theme.COLORS.MUTED}
                      onToggle={(value) => {
                        this.setState({ adminCanArm: value });
                      }}
                    />
                    <Text style={style.switchText}>
                      {translate("area.adminCanArm")}
                    </Text>
                  </View>

                  {/* armable member */}
                  <View style={style.wrapper}>
                    <Switch
                      isOn={this.state.memberCanArm}
                      size="small"
                      onColor={Theme.COLORS.ACTIVE}
                      offColor={Theme.COLORS.MUTED}
                      onToggle={(value) => {
                        this.setState({ memberCanArm: value });
                      }}
                    />
                    <Text style={style.switchText}>
                      {translate("area.memberCanArm")}
                    </Text>
                  </View>
                  {/* === Auto Join === */}
                  {/* <View style={{ flexDirection: "column" }}>
                    <View style={style.wrapper}>
                      <Switch
                        isOn={this.state.autoJoin}
                        size="small"
                        onColor={Theme.COLORS.ACTIVE}
                        offColor={Theme.COLORS.MUTED}
                        onToggle={(value) => {
                          this.setState({ autoJoin: value });
                        }}
                      />
                      <Text style={style.switchText}>
                        {translate("area.autoJoin")}
                      </Text>
                    </View>
                    <Text
                      style={{
                        fontSize: 11,
                        color: Theme.COLORS.ERROR,
                        marginVertical: 5,
                      }}
                    >
                      {translate("area.autoJoinDescription")}
                    </Text>
                  </View> */}
                </>
              )}
            </View>
          )}
          <View
            style={{
              paddingHorizontal: 20,
              paddingBottom: 30,
              borderRadius: 10,
              borderColor: "#bbb",
              borderWidth: 2,
              marginVertical: 10,
            }}
          >
            {/* Area Image  */}
            {(_isAdmin || !this.state.areaId) && (
              <View>
                {/* showAreaImage */}
                <View style={style.wrapper}>
                  <Switch
                    isOn={this.state.showAreaImage}
                    size="small"
                    onColor={Theme.COLORS.ACTIVE}
                    offColor={Theme.COLORS.MUTED}
                    onToggle={(value) => {
                      this.setState({ showAreaImage: value });
                    }}
                  />
                  <Text style={style.switchText}>
                    {translate("area.showAreaImage")}
                  </Text>
                </View>
              </View>
            )}
            {this.state.showAreaImage && (
              <View style={{ flex: 1 }}>
                <Image
                  style={style.img}
                  source={{ uri: this.state.imageSource }}
                />
                {/* <HStack space={2} justifyContent="space-between" pr={3} pl={3}> */}
                <ArButton
                  color="info"
                  style={{ height: 45 }}
                  round
                  onPress={() => this.pickImageAsync(false)}
                  paddingHorizontal={30}
                >
                  <Text style={{ color: "#FFF" }}>
                    {translate("pickImage.fromGallery")}
                    <FontAwesomeIcon
                      icon={faImage}
                      size={20}
                      color="#FFF"
                      style={{ marginLeft: 10, marginRight: 10 }}
                    />
                  </Text>
                </ArButton>
                {/* <ArButton
                    color="info"
                    style={style.btnPickImageAr}
                    round
                    onPress={() => this.pickImageAsync(true)}
                  >
                    <Text style={{ color: "#FFF" }}>
                      {translate("pickImage.fromCamera")}
                      <FontAwesomeIcon icon={faCamera} size={20} color="#FFF" style={{marginLeft: 10, marginRight: 10}} />
                    </Text>
                  </ArButton> */}
                {/* </HStack> */}
              </View>
            )}
          </View>
        </ScrollView>
        {/* submit buttons */}
        <HStack space={2} style={{ paddingHorizontal: 10 }}>
          {(_isAdmin || !this.state.areaId) && (
            <ArButton
              color="primary"
              onPress={() => this.save()}
              style={{ ...style.btnDevices, flex: 1 }}
            >
              {translate("app.save")}
            </ArButton>
          )}
          <ArButton
            color="muted"
            variant="outline"
            onPress={() => this.goBack()}
            style={{ ...style.btnDevices, flex: 1 }}
          >
            {translate("app.goBack")}
          </ArButton>
        </HStack>
        {/** validation alert */}
        {this.state.showingValidationErrors && (
          <AlertDialogBase
            isOpen={true}
            cancelText={translate("app.close")}
            cancelVariant="outline"
            onClose={() => this.hideAlert()}
          >
            <Text>{this.state.validationErrors}</Text>
          </AlertDialogBase>
        )}
      </KeyboardAvoidingView>
    );
  }
}

const btnStyle = {
  flex: 1,
  margin: 3,
  padding: 3,
  borderRadius: 3,
  height: 45,
  alignItems: "center",
  justifyContent: "center",
};

const style = StyleSheet.create({
  container: {
    paddingHorizontal: 10,
    marginBottom: 10,
  },
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
    marginTop: 20,
  },
  img: {
    borderColor: "#eee",
    borderWidth: 1,
    borderRadius: 15,
    // marginHorizontal: 'auto',
    marginVertical: 5,
    resizeMode: "center",
    alignSelf: "center",
    width: Dimensions.get("window").width / 2,
    height: Dimensions.get("window").width / 4, //* (9 / 16),
  },
  txtInput: {
    borderWidth: 1,
    borderColor: "navy",
  },
  btnPickImage: {
    ...btnStyle,
    borderWidth: 1,
    borderColor: "#ddd",
    backgroundColor: "#FFF",
    width: "100%",
  },
  btnPickImageAr: {
    // marginVertical: 3
    width: "50%",
    height: 45,
  },
  btnPickImageGroup_Show: {
    position: "absolute",
    flex: 1,
    alignItems: "center",
    width: "100%",
    height: "100%",
    paddingVertical: 10,
    justifyContent: "space-around",
    backgroundColor: "#FFFA",
  },
  btnPickImageGroup_Hide: {
    display: "none",
  },

  btnDevices: {
    flex: 1,
    width: "100%",
  },
  wrapper: {
    flexDirection: "row",
    flex: 1,
    marginTop: 25,
    alignItems: "center",
  },
  switchText: {
    textAlign: Platform.OS == "ios" ? "left" : "auto",
    flex: 1,
    paddingHorizontal: 5,
  },
});

const mapStateToProps = (state) => {
  // console.log('state', state.AppReducer)
  return {
    AreaReducer: state.AreaReducer,
    AppReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    add: (model, accessToken) => {
      dispatch(Actions.Add(model, accessToken));
    },
    update: (model, accessToken) => {
      dispatch(Actions.Update(model, accessToken));
    },
    fetchAreaTypes: (accessToken) =>
      dispatch(Actions.GetAllAreaTypes(accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AreaFormScreen);
